import type { NudgeChannel } from "@tillix/db/enums";
import { computed } from "mobx";
import {
  idProp,
  Model,
  model,
  type ObjectMap,
  objectMap,
  prop,
} from "mobx-keystone";

@model("tenantStore")
export class TenantStore extends Model({
  globalMode: prop<boolean>(() => false),
  tenants: prop<ObjectMap<TTenant>>(() => objectMap<TTenant>([])),
  activeTenantId: prop<string | null>(),
}) {
  initialized = true;

  @computed
  get activeTenant() {
    if (!this.activeTenantId) throw new Error("No active tenant");

    return this.tenants.get(this.activeTenantId);
  }
}

export abstract class TTenant extends Model({
  refId: idProp,
  supportedNudgeChannels: prop<NudgeChannel[]>(() => []),
}) {}
